import Vue from 'vue';
import ediOrderItemTransformer from './../../transformers/ediOrderItem';

const success = (data, id, resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(ediOrderItemTransformer.fetch(errors));
};

export default (id, ediOrderItem, ediOrderItemId) => (
  new Promise((resolve, reject) => {
    ediOrderItem = ediOrderItemTransformer.send(ediOrderItem);
    Vue.$http
    .post(`/edi_orders/${id}/edi_order_items/${ediOrderItemId}/confirm`, ediOrderItem)
    .then((response) => {
      success(response.data, id, resolve);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/ediOrderItem/confirm.js